import React, { Component } from "react";



//const carouselContainer = document.querySelector(".carousel-container");

// Data for carousel


class CarouselLeftArrow extends Component {
  render() {
    return (
      <a
        href={() => false}
        className="carousel__arrow carousel__arrow--left"
        onClick={this.props.onClick}
      >
        <span className="crarrow left" />
      </a>
    );
  }
}

class CarouselRightArrow extends Component {
  render() {
    return (
      <a
        href={() => false}
        className="carousel__arrow carousel__arrow--right"
        onClick={this.props.onClick}
      >
        <span className="crarrow right" />
      </a>
    );
  }
}
// eslint-disable-next-line no-unused-vars
class CarouselIndicator extends Component {
  render() {
    return (
      <li>
        <a
          href={() => false}
          className={
            this.props.index === this.props.activeIndex
              ? "carousel__indicator carousel__indicator--active"
              : "carousel__indicator"
          }
          onClick={this.props.onClick}
        >
        {""}
        </a>
      </li>
    );
  }
}
class CarouselThumb extends Component {
    render() {
      return (
        <li>
          <a
            href={() => false}
            className={
              this.props.index === this.props.activeIndex
                ? "thumb active"
                : "thumb"
            }
            onClick={this.props.onClick}
          >
              <div className="carousel-slideimg"><img src={this.props.slide.src} alt={this.props.slide.alt} /></div>
              
          </a>
        </li>
      );
    }
  }

  class CarouselReasons extends Component {
    render() {
      return (
        <li className={
              this.props.index === this.props.activeIndex
                ? "reason active"
                : "reason "
            }
            >
          <ul className="reasonlist">
          {this.props.slide.rejected_reason.map((reject_msg, index) =>
            <li key={index}>{reject_msg}</li>
          )}
          </ul>
        </li>
      );
    }
  }


class CarouselSlide extends Component {
  render() {
    return (
      <li
        className={
          this.props.index === this.props.activeIndex
            ? "carousel__slide carousel__slide--active"
            : "carousel__slide"
        }
      >
        <div className="carousel-slide">{this.props.slide.content} </div>
        {/* <div className="carousel-slideimg"><img src={this.props.slide.src} alt={this.props.slide.alt} /></div> */}

        {/* <p>
          <strong className="carousel-slide__author">
            {this.props.slide.author}
          </strong>,
          {" "}
          <small className="carousel-slide__source">
            {this.props.slide.source}
          </small>
        </p> */}
      </li>
    );
  }
}

// Carousel wrapper component
class RejectedCarousel extends Component {
  constructor(props) {
    super(props);

    this.goToSlide = this.goToSlide.bind(this);
    this.goToPrevSlide = this.goToPrevSlide.bind(this);
    this.goToNextSlide = this.goToNextSlide.bind(this);

    this.state = {
      activeIndex: 0
    };
  }

  goToSlide(index) {
    this.setState({
      activeIndex: index
    });
  }

  goToPrevSlide(e) {
    e.preventDefault();

    let index = this.state.activeIndex;
    let { slides } = this.props;
    let slidesLength = slides.length;

    if (index < 1) {
      index = slidesLength;
    }

    --index;

    this.setState({
      activeIndex: index
    });
  }

  goToNextSlide(e) {
    e.preventDefault();

    let index = this.state.activeIndex;
    let { slides } = this.props;
    let slidesLength = slides.length - 1;

    if (index === slidesLength) {
      index = -1;
    }

    ++index;

    this.setState({
      activeIndex: index
    });
  }

  render() {
    return (
      <div className="carousel" id={this.props.id}>
        <CarouselLeftArrow onClick={e => this.goToPrevSlide(e)} />

        <ul className="carousel__slides">
          {this.props.slides.map((slide, index) =>
            <CarouselSlide
              key={index}
              index={index}
              activeIndex={this.state.activeIndex}
              slide={slide}
            />
          )}
        </ul>

        <CarouselRightArrow onClick={e => this.goToNextSlide(e)} />

        {/* <ul className="carousel__indicators">
          {this.props.slides.map((slide, index) =>
            <CarouselIndicator
              key={index}
              index={index}
              activeIndex={this.state.activeIndex}
              isActive={this.state.activeIndex==index} 
              onClick={e => this.goToSlide(index)}
            />
          )}
        </ul> */}
        <ul className="imgRejectReasons">
        {this.props.slides.map((slide, index) =>
            <CarouselReasons
              key={index}
              index={index}
              activeIndex={this.state.activeIndex}
              isActive={this.state.activeIndex === index} 
              onClick={e => this.goToSlide(index)}
              slide={slide}
            />
          )}
          </ul>
        
        <div className="thumbbx">
            <ul className="carouse-thumb">
          {this.props.slides.map((slide, index) =>
            <CarouselThumb
              key={index}
              index={index}
              activeIndex={this.state.activeIndex}
              isActive={this.state.activeIndex === index} 
              onClick={e => this.goToSlide(index)}
              slide={slide}
            />
          )}
        </ul>
        </div>
        
      </div>
    );
  }
}
//render(<Carousel slides={carouselSlidesData} />, carouselContainer);

export default RejectedCarousel;
// Render Carousel component

